import React from 'react';
import { Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from '../../styles.module.css';

export default function BillingForm({ billingForm, onChange }) {
    const { t } = useTranslation();
    return (
        <div className={css['buyer-step-form']}>
            {Object.keys(billingForm).map(name => (
                <Form.Field key={name}>
                    <Form.Label label={t(`ticket.manager.orders.invoice.label.${name}`)} />
                    <Form.Input value={billingForm[name]} onChange={({ target }) => onChange(name, target.value)} />
                </Form.Field>
            ))}
        </div>
    );
}
